import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'warning-icon',
  templateUrl: './warning-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class WarningIconComponent {}
